<template>
	<Loader v-if="loading" />
	<div v-else>
		<!-- <button v-on:click="load">Re-load</button> -->

		<Modal v-if="preview_html" v-on:close="preview_html = false;">
			<div v-html="preview_html"></div>
		</Modal>

		<Modal v-if="send_message" v-on:close="send_message = false;">
			<div>
				<textarea v-model="send_message_text" cols="60" rows="5"></textarea>
				<div class="border-top margin-top padding-top">
					<button v-on:click="sendTextMessage()" :disabled="saving || !send_message_text">Send</button>
				</div>
			</div>
		</Modal>

		<button v-on:click="send_message = true;">Send sms</button>

		<div>
			<div v-for="transaction in transactions" class="flex email-history-item">
				<div class="icon">
					<div class="svg">
						<SvgIcon name="email" v-if="transaction.type == 'email'" />
						<SvgIcon name="sms" v-if="transaction.type == 'sms'" />
						<SvgIcon name="phone" v-if="transaction.type == 'call'" />
					</div>
				</div>
				<div class="text">
					<div class="flex">
						<div style="width: 300px;" class="margin-right">
							<div class="subject" v-if="transaction.type != 'sms'">{{ transaction.subject }}</div>
							<div class="subject" v-if="transaction.type == 'sms'">
								<em>"{{ transaction.subject }}"</em>
							</div>
							<div class="date">
								{{ transaction.date ? transaction.date : 'Not sent yet' }}
								<template v-if="transaction.recipient">
									to {{ transaction.recipient }}
								</template>
							</div>
						</div>
						<div v-if="transaction.type == 'email'">
							<button :disabled="!transaction.html" class="smaller white" v-on:click="preview_html = transaction.html">Preview</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'resource',
    'id'
  ],
  data: () => ({
    loading: false,
    saving: false,
    preview_html: false,
    send_message: false,
    send_message_text: '',
    data: []
  }),
  computed: {
    transactions () {
      return this.data
    }
  },
  methods: {
    load () {
      Vue.$api.get('/email-history/' + this.resource + '/' + this.id, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.data = data
      })
    },
    sendTextMessage () {
      Vue.$api.post('/customer/' + this.id + '/text-message', {
        message: this.send_message_text
      }, {
        loader: toggle => this.saving = toggle,
        callback: () => {
          alert('Message has been queued, and will be sent shortly')

          this.load()

          this.send_message = false
        }
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
